/**
 * Portals-specific SDG icon that references SVGs from the public folder
 * instead of bundling them as inline JSX. This keeps the JS bundle smaller
 * and leverages browser caching for the SVGs.
 */

export function SdgIcon(props: { goal: number; className?: string }) {
	if (props.goal < 1 || props.goal > 17) return null;
	return <img src={`/sdgs/${props.goal}.svg`} alt="" width={40} height={40} className={props.className} />;
}
